import { Subject } from 'rxjs';
import { BlackjackTranslationsType } from '../../model/blackjack-types';
import { GameServices } from '../../services/game-services';

export class RoundInfoDividerViewModel {
  public get onGameSetupStart$() {
    return this.gameServices.blackjackGameRunner.onGameSetupStart$;
  }
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }

  private readonly onResetGameScene = new Subject<void>();

  constructor(private gameServices: GameServices) {}

  public translatedText(key: BlackjackTranslationsType) {
    return this.gameServices.gameTranslationService.getTranslation(key);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
  }
}
